<template>
  <div class="fullpage-container">
    <div class="fullpage-wp" v-fullpage="opts" ref="fullPage">
      <div
        class="page-1 page rel bg-center bg-cover"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/EA/CgIXlV6ZJ8OAInyGAADDaFkHp-k697.jpg);"
      >
        <Topbar />
        <div class="page-main color-white rfs15 fwb tc">
          <div v-animate="{ value: 'zoomIn' }">
            <div class="text">海量用户流量入口</div>
            <div class="text">强大的广告营销平台</div>
            <div class="text">效果 & 品牌营销</div>
            <div class="rfs20" style="margin: 0.5rem 0 0;">让您的投放事半功倍</div>
          </div>
        </div>
        <div class="page-footer">
          <Contact type="info" class="m-b-2" />
          <NextPage type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-2 page color-primary">
        <Header />
        <div class="page-main tc rfs12">
          <div class="color-default tl" style="margin: 0 0 0.25rem;">
            WiFi万能钥匙免费上网平台，国内顶级流量产品，为用户提供一键式免费上网体验卡位移动互联网碎片化上网第一步
          </div>
          <div class="color-default bc" flex="cross:center main:justify" style="flex-wrap: wrap; width: 3.2rem;">
            <div class="item m-b-4" v-animate="{ value: 'flipInY', delay: 0 }">
              <img src="https://static.wkanx.com/w002/M00/07/C6/CgIXGF9Paa6ATYOmAAAOfBEouXo765.png" alt="" />
              <div class="m-t-2 m-b-1">海量用户</div>
            </div>
            <div class="item m-b-4" v-animate="{ value: 'flipInY', delay: 100 }">
              <img src="https://static.wkanx.com/w002/M00/05/B2/CgIXlV6EANSAVeR7AAAICCe8Az4014.png" alt="" />
              <div class="m-t-2 m-b-1">一键连接免费网络</div>
            </div>
            <div class="item" v-animate="{ value: 'flipInY', delay: 200 }">
              <img src="https://static.wkanx.com/w002/M00/05/B2/CgIXgV6EANqAKpmKAAAGROxaGwI787.png" alt="" />
              <div class="m-t-2 m-b-1">全球用户的共同选择</div>
            </div>
            <div class="item" v-animate="{ value: 'flipInY', delay: 300 }">
              <img src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EAOeACdIvAAAJ4UvWO8Y899.png" alt="" />
              <div class="m-t-2 m-b-1">全方位专业安全防护</div>
            </div>
          </div>
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-3 page color-primary">
        <Header />
        <div class="page-main color-default rfs12">
          <div class="m-b-2">
            通过用户连接WiFi的POI信息，形成覆盖用户半径1-5公里范围内的传播矩阵形成更加精准的场景化投放方案，让客户更精准触达希望区域内的用户
          </div>
          <div class="tc m-t-3">
            <div class="fwb">选择POI（point of intrest）</div>
            <div class="m-b-2">后台有可选POI，支持自定义</div>
            <img
              class="db bc"
              src="https://static.wkanx.com/w002/M00/05/B2/CgIXlV6EAgCAHPPTAAEivi_CDjo247.png"
              style="width: 3.23rem;"
            />
          </div>
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-4 page">
        <Header />
        <div class="page-main color-default tc rfs12">
          <div class="tl">
            通过用户连接WiFi的POI信息，形成覆盖用户半径1-5公里范围内的传播矩阵形成更加精准的场景化投放方案，让客户更精准触达希望区域内的用户
          </div>
          <div class="fwb m-t-3">用户定向</div>
          <div class="m-b-3">设定属性和兴趣标签</div>
          <img
            class="db bc"
            src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EBCqAOKB4AABdCW3t84c182.png"
            style="width: 2.08rem;"
          />
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-5 page">
        <Header />
        <div class="page-main color-default tc rfs12">
          <div class="tl">
            通过用户连接WiFi的POI信息，形成覆盖用户半径1-5公里范围内的传播矩阵形成更加精准的场景化投放方案，让客户更精准触达希望区域内的用户
          </div>
          <div class="fwb m-t-3">广告推送</div>
          <div class="m-b-3">基于POI的广告创意</div>
          <img
            class="db bc"
            src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EBG2AMVKBAABON8sFNG4113.png"
            style="width: 1.2rem;"
          />
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-6 page">
        <Header />
        <div class="page-main color-default tc rfs12">
          <div>数据精算：标签化建模，实现规模化的高精准触达</div>
          <div class="m-t-6 m-b-3">精准投放原理：场景定向+属性定向+兴趣定向</div>
          <div flex="main:center cross:bottom" class="tc">
            <div class="m-r-2">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6ECSuALrLwAABpMgt6uLE324.png"
                style="width: 2.08rem;"
              />
              <div class="m-t-5">标签</div>
            </div>
            <div>
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXgV6ECXGAI2xxAAA3s9Pjbds114.png"
                style="width: 1rem;"
              />
              <div class="m-t-5">定位TA</div>
            </div>
          </div>
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-7 page">
        <Header />
        <div class="page-main color-default tc rfs12">
          <div>AI程序化创意，让广告投放更简单、优化更容易</div>
          <div class="m-t-3 tl">
            <div flex="cross:center" class="m-t-3" v-animate="{ value: 'slideInRight', delay: 0 }">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXgV6ECzGAIBeDAAAccLjtLmY915.png"
                style="width: 0.76rem;"
                alt=""
              />
              <div class="m-l-2">
                <div class="fwb m-b-1">创意设计师</div>
                <div class="tl">通过了解不同素材的投放效果，为素材制作商提供自动数据支持，具有一定的参考价值</div>
              </div>
            </div>
            <div flex="cross:center" class="m-t-3" v-animate="{ value: 'slideInRight', delay: 50 }">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXlV6EDB-AW35pAAAk7IRNH1M221.png"
                style="width: 0.76rem;"
                alt=""
              />
              <div class="m-l-2">
                <div class="fwb m-b-1">预算自动优化</div>
                <div class="tl">
                  自动预算倾斜给投放效果好的推广活动，灵活分配用于测试推广活动的预算，并减少推广效果差的推广活动预算的浪费。
                </div>
              </div>
            </div>
            <div flex="cross:center" class="m-t-3" v-animate="{ value: 'slideInRight', delay: 100 }">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EDCiABF_XAAAdNQza46g180.png"
                style="width: 0.76rem;"
                alt=""
              />
              <div class="m-l-2">
                <div class="fwb m-b-1">增值优化师</div>
                <div class="tl">高效创建图片和标题各种组合的创意，并快速测试新创意的投放效果，优选出符合需求的素材</div>
              </div>
            </div>
          </div>
        </div>
        <Contact class="page-footer m-b-6" />
      </div>
    </div>
  </div>
</template>
<script>
import Base from './Base';

export default {
  name: '',
  props: {},
  extends: Base,
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.page-1 {
  .text {
    line-height: 0.4rem;
  }
}
.page-2 {
  .item {
    width: 50%;
  }
  img {
    width: 0.6rem;
  }
}
</style>
